import { useMutation } from 'react-query';
import { resendEmailValidation } from '@simplywallst/services';

export function useResendEmailValidation() {
  return useMutation({
    mutationFn: async (email: string) => {
      const result = await resendEmailValidation({ email });
      return result;
    },
    mutationKey: ['RESEND-VALIDATION-EMAIL'],
  });
}
